// pages/User/components/UserHeader.jsx
import { BiLogoFacebook } from 'react-icons/bi';
import { IoLogoInstagram } from 'react-icons/io5';
import { MdLocationOn, MdVerified } from 'react-icons/md';
import errorImage from '@/utils/errorImage';
import { useTranslation } from 'react-i18next';

const UserHeader = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div className='overflow-hidden rounded-xl bg-white shadow-xl'>
      {/* Cover Background */}
      <div className='h-32 bg-gradient-to-r from-primary-yellow via-yellow-400 to-primary-yellow'></div>

      <div className='px-6 pb-6'>
        {/* Profile Section */}
        <div className='relative -mt-16 flex flex-col gap-6 md:flex-row'>
          {/* Avatar */}
          <div className='z-10 flex-shrink-0'>
            <div className='relative'>
              <img
                alt='profile'
                src={user?.profileImage || '/images/default-profile.png'}
                className='h-32 w-32 rounded-full border-4 border-white bg-white object-cover shadow-lg'
                onError={errorImage}
              />
              {user?.active && (
                <div className='absolute bottom-2 right-2 flex h-8 w-8 items-center justify-center rounded-full border-4 border-white bg-green-500'>
                  <MdVerified className='text-sm text-white' />
                </div>
              )}
            </div>
          </div>

          {/* User Info */}
          <div className='flex-grow pt-4 md:pt-16'>
            <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
              {/* Name & Company */}
              <div>
                <div className='mb-2 flex items-center gap-2'>
                  <h1 className='text-2xl font-bold text-gray-800 lg:text-3xl'>
                    {user?.firstName} {user?.lastName}
                  </h1>
                  {user?.role === 'admin' && (
                    <span className='rounded-full bg-primary-yellow px-3 py-1 text-xs font-bold text-gray-800'>{t('admin')}</span>
                  )}
                </div>

                {user?.city && (
                  <div className='flex items-center gap-2 text-gray-500'>
                    <MdLocationOn className='text-lg' />
                    <p>{user.city}</p>
                  </div>
                )}
              </div>

              {/* Social Links */}
              <div className='flex items-center gap-3'>
                {user?.facebook && (
                  <a
                    href={user.facebook}
                    target='_blank'
                    rel='noreferrer'
                    className='flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 transition-colors hover:bg-primary-yellow'
                    aria-label='Facebook'
                  >
                    <BiLogoFacebook className='text-xl text-gray-700' />
                  </a>
                )}
                {user?.instagram && (
                  <a
                    href={user.instagram}
                    target='_blank'
                    rel='noreferrer'
                    className='flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 transition-colors hover:bg-primary-yellow'
                    aria-label='Instagram'
                  >
                    <IoLogoInstagram className='text-xl text-gray-700' />
                  </a>
                )}
              </div>
            </div>

            {/* No additional sections when data is not available */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserHeader;
